import { Component, Inject } from '@angular/core';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChatService } from '../utilities/services/chat.service';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from '../idle-timeout-dialog/confirmDialog'

export interface ConfirmationDialogData {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

interface NotificationReference {
  text: string;
  link: string;
}

export enum NotificationStatus {
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  DELIVERED = 'DELIVERED',
  READ = 'READ',
}

interface NotificationItem {
  _id: string;
  read: boolean;
  reference: NotificationReference;
  status: string;
  date: Date;
  message: string;
}

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent {
  public notifications: NotificationItem[] = [];

  public hasUnread = false;
  private shown = false;
  private notificationsMap = new Map(); // we use a map to avoid having duplicate notifications

  ngAfterViewInit(): void {

  }

  constructor(private dialog: MatDialog, private chatService: ChatService, private _snackBar: MatSnackBar, public router: Router) {

  }

  isNotificationLinkInternal(notification: any) {
    return notification["reference"]["link"][0] == "/"
  }

  // the public notifications: NotificationItem[] is our sorted notifications list its what the html is reading from
  updateSortedNotifications(showSnackbar: boolean) {
    let notificationMapArray = Array.from(this.notificationsMap)
      .sort(([notiId1, notiObj1], [notiId2, notiObj2]) => // label's would be the keys as its a map
        new Date(notiObj2.createTime).getTime() - new Date(notiObj1.createTime).getTime()); // sort ascending / newest to oldest

    this.notifications = [];

    for (let noti of notificationMapArray) {

      noti = noti[1]; // select the value as it was a map
      this.hasUnread = this.hasUnread || noti["status"] != NotificationStatus.READ;

      // Commented out code below as I think the snackbar is overloading and freezing the screen if a lot of them come in at once on login
      // if (this.hasUnread && showSnackbar) {
      //   this._snackBar.open(noti["title"], noti["body"], {
      //     duration: 2000,
      //   });
      // }

      this.notifications.push({
        _id: noti["notificationId"],
        read: noti["status"] == NotificationStatus.READ, // if set to read read will = true
        reference: { text: noti["body"], link: noti["bodyRef"] },
        status: 'status',
        date: new Date(noti["createTime"]),
        message: noti["title"],
      })
    }
  }

  ngOnInit(): void {
    this.hasUnread = false;

    this.chatService.on('notificationReceive', (message) => {
      // console.log("Notification", message)
      this.notificationsMap.set(message["notificationId"], message);

      // console.log(this.notificationsMap)

      this.updateSortedNotifications(false);
    })
  }

  goto(notification: any) {
    let isMobile = window.innerWidth <= 768;
    if (isMobile) {
      this.toggleVisibility();
    }
    let linkTo = notification["reference"]["link"];
    let linkFrom = this.router.url;
    if (linkTo === linkFrom) { }
    else if (linkTo.indexOf("threads/edit/") > -1 && linkFrom.indexOf("threads/edit/") > -1) {
      this.router.navigate([notification["reference"]["link"]]).then(() => {
        window.location.reload()
      })
    } else
      this.router.navigate([notification["reference"]["link"]]);
  }

  archive(notification: any, index: number) {

    // const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
    //   width: '400px',
    //   data: { message: 'archive this notification?' },
    // });

    // dialogRef.afterClosed().subscribe((confirmed: boolean | undefined) => {
    //   if (!confirmed) {
    //     return;
    //   }

    //   this.chatService.emit('notificationArchive', notification["_id"]);
    //   this.notificationsMap.delete(notification["_id"]);
    //   this.updateSortedNotifications(false);
    // });

    if (confirm('Are you sure you want to archive this notification?')) {
      this.chatService.emit('notificationArchive', notification["_id"])
      this.notificationsMap.delete(notification["_id"]);
      this.updateSortedNotifications(false);
    }
  }

  isShown(): boolean {
    return this.shown;
  }

  toggleVisibility(): void {
    this.shown = !this.shown;
    for (let noti of this.notifications) {
      if (!this.shown) { // tell server we have read notifications and set are notifications to read
        if (!noti.read) { // if unread tell serve we read and set as read on client 
          this.chatService.emit('notificationRead', { notificationId: noti._id })
          noti.read = true;
        }
      }
    }
    this.hasUnread = false; // since we are reading all noti's no reason to check all noti's are read
  }

}
